import vhCheck from 'vh-check';
import { isTouch } from '../_helpers';
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

import Carousels from '../_modules/carousels';
import Search from '../_components/03-organisms/search-dropdown/search';
import DateTimeConverter from '../_components/03-organisms/dateTimeConverter/dateTimeConverter';

vhCheck();

window.disableBodyScroll = disableBodyScroll;
window.enableBodyScroll = enableBodyScroll;
window.clearAllBodyScrollLocks = clearAllBodyScrollLocks;

!isTouch && document.body.classList.add('no-touch');
isTouch && document.body.classList.add('is-touch');

const CAROUSELS = new Carousels();
const SEARCH = new Search();
const DATETIMECONVERTER = new DateTimeConverter();
